import { ServiceAreasContent } from '@fingertip/creator-proto/gen/fingertip/common/type/v1/block_schema_pb'
import { useState } from 'react'

import {
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { ResponsiveSheet } from '@/components/ui/responsive-sheet'
import { ResponsiveSheetContent } from '@/components/ui/responsive-sheet-content'
import { cn } from '@/lib/utils/cn'

import { BlockProps } from '../shared/block-switch'
import { ServiceAreasInner } from './service-areas-inner'

export const ServiceAreasBlock = ({
  block,
  h,
  w,
  viewportWidth,
  scaleFactor,
}: BlockProps) => {
  const [open, setOpen] = useState(false)
  const content = block?.content?.content?.value as ServiceAreasContent

  return (
    <ResponsiveSheet open={open} onOpenChange={setOpen}>
      <DialogTrigger
        className={cn(
          'cursor-pointer outline-hidden! flex size-full flex-col p-block',
          {
            'justify-center h-full': h <= 2,
          },
        )}
      >
        <ServiceAreasInner
          content={content}
          h={h}
          w={w}
          viewportWidth={viewportWidth}
          scaleFactor={scaleFactor}
        />
      </DialogTrigger>

      <ResponsiveSheetContent className="max-h-[calc(100vh-100px)] overflow-y-auto font-page-body font-page-body-weight">
        {content?.title && (
          <DialogHeader>
            <DialogTitle className="font-page-heading font-page-heading-weight! text-2xl!">
              {content.title}
            </DialogTitle>
          </DialogHeader>
        )}

        <div className="flex-1">
          <div className="flex flex-col gap-1">
            {(content?.serviceAreas || []).map((item, index) => (
              <div key={index} className="text-left">
                {item.title}
              </div>
            ))}
          </div>
        </div>
      </ResponsiveSheetContent>
    </ResponsiveSheet>
  )
}
